export default __webpack_public_path__ + "static/media/hnida-logistik.13d7b121.svg";